import styled from 'styled-components'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const primaryColor = '#404040'
const dangerColor = '#404040'

// -WRAPPER
export const InputWrapper = styled.div`
  margin-bottom: .7em;
  position: relative ;
  color: ${primaryColor};
`

// -WRAPPER -LABEL
export const InputLabel = styled.label<{
    align?: 'left' | 'center' | 'right'
}>`
    padding: 0.2em 0.5em 0.2em 0;
    line-height: 1.4;
    color: rgba(0, 0, 0, 0.5);
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    margin-bottom: 0;
    text-align: ${({align}) => align ? align : 'inherit'};
`

// -WRAPPER -LABEL -HELP-CONTAINER
export const HelpContainer = styled.div`
    position: relative;
    display: inline-block;
    margin-left: .5em;
`

// -WRAPPER -LABEL -HELP-CONTAINER -ICON
export const HelpIcon = styled(FontAwesomeIcon)`
      color: ${primaryColor};
`

// -WRAPPER -LABEL -HELP-CONTAINER -TEXT
export const HelpText = styled.div<{
    open: boolean
}>`
      position: absolute;
      background-color: white;
      z-index: 1;
      border: 1px solid ${primaryColor};
      width: 20em;
      left: 1.5em;
      top: 0;
      padding: 1em;
      white-space: normal;
      display: ${({open}) => open ? 'block' : 'none'};
`

// -WRAPPER -ERROR
export const ErrorContainer = styled.div`
    color: white;
    position: absolute;
    background-color: ${dangerColor};
    padding: .5em;
    border-radius: 5px;
    width: auto;
    top: 0;
    right: 0;
    font-size: 0.9em;
    &:after {
      content: "";
      position: absolute;
      right: 0.4em;
      top: 100%;
      border-top: 0.5em solid ${dangerColor};
      border-left: 0.5em solid transparent;
    }
`

// -WRAPPER -INPUT
export const InputField = styled.input<{
    align?: 'left' | 'center' | 'right'
    inputStyle?: 'line' | 'rounded'
}>`
    border: 0;
    margin: 0;
    padding: 0.2em 0;
    appearance: none;
    background: none;
    border-radius: 0;
    line-height: 1.4;
    width: 100%;
    outline: none;
    text-align: ${({align}) => align ? align : 'inherit'};
  ${({ inputStyle }) => inputStyle === 'line' && `
      border-bottom: 1px solid rgba(0,0,0,0.15);
      &:focus {
        border-bottom: 1px solid ${primaryColor};
      }
  `}
    ${({ inputStyle }) => inputStyle === 'rounded' && `
      border: 1px solid rgba(0,0,0,0.2);
      border-radius: 50px;
      padding: .5em;
      &:focus {
        border-color: ${primaryColor};
      }
  `}
`
